import React, {Component, PropTypes} from 'react';
import ClientSideCacheController from '../ClientSideCacheController'
import ZipInput from '../ZipInput'
import Analytics from '../Analytics'
class CurrentConditions extends Component {
  constructor(props) { //gives us acces to props, fires long before page load
    super(props) //assigns props to this.props
    this.affiliate = props.affiliate;

    this.state = {
      radarImg: 'https://ftpcontent.worldnow.com/kotv/MyOwnRadar/kotv/ssite/110x62/main_anim.gif?' + Date.now()
    }
  }

  componentDidMount() {
      ClientSideCacheController.setAffiliate(this.props.affiliate)
      ClientSideCacheController.get('forecast').then((data)=>{
        this.setState(data)
      })

  }



  render() {
    return (
      <div className='gnm-current-conditions'>
          <ZipInput>
            <a href='#current-conditions-zip-code-picker' className={' hidden-xs hidden-sm hidden-md map-link' + (this.state.temp
                  ? ''
                  : ' hidden')/* on one occassion, this value was unset */}>{this.state.city}, {this.state.state}
                  <span className='glyphicon glyphicon-map-marker' />
            </a>
          </ZipInput>
          <a href="/weather" >
            <img className='pull-left condition-icon' src={this.state.conditionIcon} />
            <span className={'pull-left temperature' + (this.state.temp
                ? ''
                : ' hidden')/* on one occassion, this value was unset */}>{this.state.temp}&deg;</span>
          </a>

          <a href={this.props.affiliate === 'kwtv'? '/esp-radar' : '/warn-interactive-live-radar'} className='hidden-xs hidden-sm hidden-md  radar-img pull-left'>
            <img className='' src={this.state.radarImg} aria-label='radar image' onError={(e)=>{
                let error = new Error('*Back-end* Radar image at ' + this.state.radarImg + ' is not responding')
                Analytics.reportError(error)
                 }}/>
          </a>
          <span className="feels-like hidden-xs hidden-sm"> Feels like {this.state.feelsLike}&deg;</span>
      </div>
    )
  }
}

export default CurrentConditions;



// WEBPACK FOOTER //
// ./app/components/custom/ssr/Header/CurrentConditions.js